import { render } from "./Arr.vue?vue&type=template&id=356f2b7c"
import script from "./Arr.vue?vue&type=script&lang=js"
export * from "./Arr.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__